const API_URL = 'https://api.dastaan.info/api/v1/guest-visit-log';

const logged = new Set();

export const logGuestVisit = (screen) => {
  if (logged.has(screen)) return;
  logged.add(screen);

  const utm_source = new URLSearchParams(window.location.search).get('utm_source');
  const domain = window.location.hostname;

  const body = { screen, domain };
  if (utm_source) body.utm_source = utm_source;

  fetch(API_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  }).catch(() => {});
};
